import React, { useCallback, useContext, useEffect, useState } from "react";
import {
  Button,
  DatePicker,
  Form,
  Input,
  Modal,
  Space,
  Table,
  Tooltip,
} from "antd";
import axios from "axios";
import moment from "moment";
import { NotificationInfo, UserInfo } from "../../../../context";
import {
  AuditOutlined,
  CalendarOutlined,
  InfoCircleOutlined,
  CarOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import MerchantAddReturnProduct from "./MerchantAddReturnProduct";
import MerchantReturnDetails from "./MerchantReturnDetails";
// import MerchantAddDeliveryOrder from "./MerchantAddDeliveryOrder";
// import MerchantInvoiceDetails from "./MerchantInvoiceDetails";
// import MerchantPaymentDetails from "../../../commissary/delivery/merchant-order/MerchantPaymentDetails";

const MerchantReturnToSupplier = () => {
  const [merchantReturnList, setMerchantReturnList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const scroll = {};
  const { userData } = useContext(UserInfo);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openFilterByDate, setOpenFilterByDate] = useState(false);
  const { rerunNotif } = useContext(NotificationInfo);
  const [openDrawerPayment, setOpenDrawerPayment] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [arriveDialog, setArriveDialog] = useState(false);
  const [search, setSearch] = useState("");
  const [selectedTab, setSelectedTab] = useState("list");

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Created Date",
      dataIndex: "created_at",
      render: (date) => (
        <p>{moment.utc(new Date(date)).format("MMMM DD, YYYY")}</p>
      ),
    },
    {
      title: "Reference #",
      dataIndex: "ref_number",
      sorter: (a, b) => a.ref_number - b.ref_number,
      render: (text, record) => (
        <p
          style={{
            textTransform: "uppercase",
            fontWeight: "bold",
          }}
        >
          {text}
        </p>
      ),
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      width: 40,
      render: (text) => (
        <p>
          <Tooltip title="Details">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setOpenDrawer(true);
              }}
              icon={<AuditOutlined />}
              style={{ marginRight: 5 }}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getMerchantReturnList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/merchant/merchant-return-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setMerchantReturnList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getMerchantReturnList();
  }, [getMerchantReturnList]);

  const searchable = merchantReturnList.data.filter((data) => {
    return data.ref_number.toLowerCase().indexOf(search.toLowerCase()) >= 0;
  });

  // const handleOk = () => {
  //   setConfirmLoading(true);
  //   setTimeout(() => {
  //     setArriveDialog(false);
  //     setConfirmLoading(false);
  //     handleSetArrivedStatus();
  //   }, 2000);
  // };

  // const handleSetArrivedStatus = () => {
  //   const formdata = new FormData();

  //   formdata.append("user_id", userData.data.id);
  //   formdata.append(
  //     "po_number",
  //     selectedData !== null ? selectedData.po_number : ""
  //   );
  //   formdata.append(
  //     "po_number_id",
  //     selectedData !== null ? selectedData.po_number_id : ""
  //   );

  //   // setLoadings(true);
  //   axios
  //     .post("user/merchant/update-po-into-arrived", formdata)
  //     .then((response) => {
  //       const data = response.data;
  //       if (data === "success") {
  //         rerunNotif("success", "Updated P.O successfully.");
  //         setTimeout(() => {
  //           // setLoadings(false);
  //           getMerchantReturnList();
  //         }, 1000);
  //       }
  //     })
  //     .catch((error) => {
  //       console.log("ERROR: ", error);
  //       // setLoadings(false);
  //     });
  // };

  const handleFilter = (values) => {
    var params = {
      // date_from: moment(new Date(values.date_from), "YYYY-MM-DD").format(
      //   "YYYY-MM-DD"
      // ),
      // date_to: moment(new Date(values.date_to), "YYYY-MM-DD").format(
      //   "YYYY-MM-DD"
      // ),
      date_from: moment(new Date(values.date_from)).format("YYYY-MM-DD"),
      date_to: moment(new Date(values.date_to)).format("YYYY-MM-DD"),
      user_id: userData.data.id,
    };
    setLoading(true);
    axios
      .get("user/merchant/filter/merchant-return-list", { params })
      .then((response) => {
        const data = response.data;
        rerunNotif("success", "Filter successful.");
        setTimeout(() => {
          setOpenFilterByDate(false);
          setLoading(false);
          setMerchantReturnList({ data, ready: true });
        }, 1000);
      })
      .catch((error) => {
        console.log("Error: ", error);
        // setLoadings(false);
      });
  };

  return (
    <>
      {selectedTab === "list" && (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: 5,
            }}
          >
            <div style={{ flexGrow: 1 }}>
              <Input
                id="search"
                placeholder="Search Reference #"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                style={{
                  border: "2px solid #e5e5e5",
                  width: window.innerWidth < 576 ? "100%" : 300,
                }}
                size="large"
              />
            </div>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => setSelectedTab("form")}
            >
              Add Return Product
            </Button>
            <Tooltip title="Filter by date">
              <Button
                icon={<CalendarOutlined />}
                style={{ marginLeft: 5 }}
                onClick={() => setOpenFilterByDate(true)}
              >
                Filter
              </Button>
            </Tooltip>
          </div>
          <div style={{ overflowX: "auto" }}>
            <Table
              {...tableProps}
              pagination={{
                position: ["bottomCenter"],
              }}
              columns={tableColumns}
              dataSource={searchable.length > 0 ? searchable : []}
              scroll={scroll}
              rowKey={(record) => record.ref_number}
            />
          </div>
        </>
      )}

      {selectedTab === "form" && (
        <MerchantAddReturnProduct
          close={() => setSelectedTab("list")}
          getMerchantReturnList={() => getMerchantReturnList()}
        />
      )}

      {/* {openDrawer && (
        <MerchantInvoiceDetails
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          setLoading={setLoading}
          getMerchantReturnList={() => getMerchantReturnList()}
          selectedData={selectedData}
        />
      )} */}

      {openDrawer && (
        <MerchantReturnDetails
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          selectedData={selectedData}
        />
      )}

      <Modal
        title=""
        open={openFilterByDate}
        onCancel={() => setOpenFilterByDate(false)}
        footer={null}
        width={350}
        centered
      >
        <Form
          layout="vertical"
          name="return-filter"
          initialValues={{ remember: false }}
          onFinish={handleFilter}
          autoComplete="off"
        >
          <Space
            direction="vertical"
            style={{ width: "100%", margin: 0, marginTop: 20 }}
          >
            <Form.Item
              name="date_from"
              label="Date From"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <DatePicker
                format={"MM/DD/YYYY"}
                size="large"
                style={{ width: "100%" }}
              />
            </Form.Item>

            <Form.Item
              name="date_to"
              label="Date To"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <DatePicker
                format={"MM/DD/YYYY"}
                size="large"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Space>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              loading={loading}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
            >
              {loading ? "Loading" : "Filter"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>

      {/* {openDrawerPayment && (
        <MerchantPaymentDetails
          open={openDrawerPayment}
          close={() => setOpenDrawerPayment(false)}
          selectedData={selectedData}
        />
      )} */}

      {/* <Modal
        title="Are you sure to set status into arrived?"
        open={arriveDialog}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setArriveDialog(false)}
      /> */}
    </>
  );
};

export default MerchantReturnToSupplier;
